import { FormError } from "@3gaam/shared/types/error";
import React, { InputHTMLAttributes } from "react";
import Icon from "../icon";

export type TextFieldProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "name"
> & {
  name?: InputHTMLAttributes<HTMLInputElement>["name"];
  onChange?: (e: any, param?: any) => void;
  icon?: string;
  error?: FormError;
};
const TextField = ({
  name,
  className = "",
  icon,
  children,
  error,
  onChange,
  ...rest
}: TextFieldProps) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div className={`inp-box ${showError ? "invalid-field" : ""}`}>
        {icon && (
          <span className="inp-icon">
            <Icon name={icon} />
          </span>
        )}
        <input
          className={`rounded-6 form-control ${
            icon ? "pl-5" : ""
          } ${className}`}
          type="text"
          name={name || undefined}
          onChange={(event) => {
            if (!onChange) return;
            onChange(event);
          }}
          {...rest}
        />
        {children}
      </div>
      {name && showError && (
        <p className="text-red font-10 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

export default React.memo(TextField);
